import { useEffect, useState } from "react";

interface LoopTiming {
  /** Espera antes de começar a contar (ms). */
  start: number;
  /** Intervalo entre cada incremento (ms). */
  step: number;
  /** Tempo parado no valor máximo antes de recomeçar (ms). */
  hold: number;
}

const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Conta de 0 até `max` em loop, usado nas animações do hero.
 * Com "reduzir movimento" ativo, devolve `max` direto e não anima.
 */
export function useLoopedCount(max: number, { start, step, hold }: LoopTiming) {
  const [reducedMotion] = useState(prefersReducedMotion);
  const [count, setCount] = useState(reducedMotion ? max : 0);

  useEffect(() => {
    if (reducedMotion) return;
    let timeout = 0;
    const run = (value: number) => {
      setCount(value);
      const delay = value === 0 ? start : value < max ? step : hold;
      timeout = window.setTimeout(() => run(value < max ? value + 1 : 0), delay);
    };
    run(0);
    return () => window.clearTimeout(timeout);
  }, [max, start, step, hold, reducedMotion]);

  return count;
}
